import React from 'react'
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
`;

const HeaderImageWrapper = styled.figure`
  width: 100%;
  max-width: 552.2px;
  min-width: 552.2px;
  height: 100%;
  max-height: 581.1px;
  min-height: 581.1px;
  background-color: lightgray;
  border-radius: 5px;
  animation: ${pulse} 2s infinite;
  @media (max-width: 480px) {
    max-width: 378px;
    margin: 32px 0 32px 0;
    max-height: 400px;
  }
`;

export const ImageSkeleton = () => {
  return (
    <HeaderImageWrapper>
      
    </HeaderImageWrapper>
  )
}

